// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"1673559c","638":"761a6f98"}[chunkId] + ".chunk.css";
};